// "no-unknown-property" is broken so disabling it...
/* eslint-disable react/no-unknown-property */
import React, { useState, useRef } from 'react'
import { makeStyles, useTheme, Popover } from '@material-ui/core'
import GlueScroll from './glue-scroll'
import GlueListItem from './glue-list-item'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

// import { clickAudio, hoverAudio } from './common-vuplex-messages';
import GlueIcon from './glue-icon'

const idIsValid = (id) => {
  if (!id) {
    return id === 0
  }
  return true
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: ({ width }) => width,
    minWidth: ({ width }) => !width && theme.custom.glueDropdown.minWidth,
    height: theme.custom.glueDropdown.height
  },

  header: {
    width: '100%',
    height: '100%',

    background: ({ open }) => open ? theme.palette.dropdown.active : theme.palette.dropdown.main,

    borderTopLeftRadius: ({ open, invert }) => open && invert ? 0 : theme.custom.glueDropdown.borderRadius,
    borderTopRightRadius: ({ open, invert }) => open && invert ? 0 : theme.custom.glueDropdown.borderRadius,
    borderBottomLeftRadius: ({ open, invert }) => open && !invert ? 0 : theme.custom.glueDropdown.borderRadius,
    borderBottomRightRadius: ({ open, invert }) => open && !invert ? 0 : theme.custom.glueDropdown.borderRadius,
    borderColor: theme.custom.glueDropdown.borderColor,
    borderStyle: ({ open }) => !open && theme.custom.glueDropdown.borderStyle,
    borderWidth: theme.custom.glueDropdown.borderWidth,

    cursor: 'pointer',
    display: 'inline-flex'
  },

  clickArea: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',

    '& > :last-child': {
      alignItems: 'flex-end'
    },

    '&:hover': {
      background: theme.palette.dropdown.hover,
      color: theme.palette.dropdown.textHover
    }
  },

  label: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    marginLeft: theme.spacing('m'),
    marginRight: 'auto'
  },

  popover: {
    background: theme.palette.dropdown.main,
    borderRadius: theme.custom.glueDropdown.borderRadius,
    borderColor: theme.custom.glueDropdown.borderColor,
    borderStyle: theme.custom.glueDropdown.borderStyle,
    borderWidth: theme.custom.glueDropdown.borderWidth,
    width: ({ listWidth }) => `${listWidth}px`,
    oveflow: 'hidden',

    transition: 'none !important'
  },

  list: {
    maxHeight: ({ listHeight }) => `${listHeight}px`
  }
}), { name: 'MuiGlueDropdown' })

const GlueDropdownHeader = (props) => {
  const selectedId = !props.multiple && (Array.isArray(props.selected) ? props.selected.length === 1 && props.selected[0] : props.selected)
  const label = (!props.perpetualLabel && idIsValid(selectedId) && props.items?.find(i => i?.id === selectedId))?.name ?? props.label
  // This is the worst and I hate it, I hate web development
  const customLabel = label && (typeof label !== 'string')

  return (
    <div className={props.classes.header} ref={props.anchorRef} onWheel={(e) => e.stopPropagation()}>
      {customLabel && <div>{label}</div>}
      <div className={props.classes.clickArea} onPointerDown={props.onPointerDown} onPointerEnter={props.onPointerEnter}>
        {!customLabel &&
          <div className={props.classes.label}>
            {label}
          </div>
        }
        <GlueIcon>
          {props.open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </GlueIcon>
      </div>
    </div>
  )
}

const GlueDropdown = (props) => {
  const [ open, setOpen ] = useState(false)
  const [ selected, setSelected ] = useState(props.defaultValue ?? [])

  const value = props.value ?? selected

  const anchorRef = useRef()

  const theme = useTheme()

  let invert = false
  let listWidth = 0
  let listHeight = 0
  // Figure out if dropdown should open up instead
  // It's probably ok to do this only on rerender
  if (anchorRef.current && props.items) {
    const itemHeight = parseFloat(theme.custom.glueListItem.height)
    const headerHeight = parseFloat(theme.custom.glueDropdown.height)
    const preferredHeight = props.items.length * itemHeight + headerHeight
    const boundingRect = anchorRef.current.getBoundingClientRect()

    let possibleHeight = window.innerHeight - boundingRect.bottom
    if (possibleHeight < preferredHeight) {
      // Is there more room on top, invert
      if (boundingRect.top > possibleHeight) {
        invert = true
        possibleHeight = boundingRect.top
      }

      listHeight = Math.floor((possibleHeight - headerHeight) / itemHeight) * itemHeight
    } else {
      listHeight = preferredHeight - headerHeight
    }

    listWidth = anchorRef.current.offsetWidth
  }

  const classes = useStyles({ ...props, open, invert, listHeight, listWidth })

  const selectItem = (id) => {
    let checked = true

    if (props.multiple) {
      const newSelected = [...selected]
      const existingIndex = newSelected.findIndex(i => i === id)
      if (existingIndex !== -1) {
        newSelected.splice(existingIndex, 1)
        checked = false
      } else {
        newSelected.push(id)
      }
      setSelected(newSelected)
    } else {
      setSelected([id])
    }

    if (props.onChange) {
      props.onChange(id, checked)
    }

    if (!props.multiple) {
      setOpen(false)
    }
  }

  const handleOpen = (state) => {
    setOpen(state)
    if (!state && props.onClose) {
      props.onClose()
    }
  }

  const drawHeader = (main) => {
    return (
      <GlueDropdownHeader
        open={open}
        onPointerDown={() => { /* clickAudio(audiomessage) */ handleOpen(!open) }}
        // onPointerEnter={() => {hoverAudio(hoveraudiomessage)}}
        anchorRef={main ? anchorRef : null}
        multiple={props.multiple}
        items={props.items}
        selected={value}
        label={props.label}
        perpetualLabel={props.perpetualLabel}
        classes={classes}
      />
    )
  }

  const itemIsSelected = (item) => {
    if (!idIsValid(item.id)) {
      return false
    }

    if (Array.isArray(value)) {
      return value.includes(item.id)
    } else {
      return value === item.id
    }
  }

  // const audiomessage = !!props.uiAudioMessage ? props.uiAudioMessage : "Menu/Generic/Button/Press";
  // const hoveraudiomessage = !!props.uiHoverAudioMessage ? props.uiHoverAudioMessage : "Menu/Generic/Button/HL";
  // const selaudiomessage = !!props.uiSelAudioMessage ? props.uiSelAudioMessage : "Menu/Generic/Button/Press";
  // const selhoveraudiomessage = !!props.uiSelHoverAudioMessage ? props.uiSelHoverAudioMessage : "Menu/Generic/Button/HL";

  return (
    <div className={classes.root}>
      {drawHeader(true)}
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
        anchorOrigin=
        transformOrigin=
        classes=
        BackdropProps= // Prevent scrolling in the background
      >
        {!invert && drawHeader(false)}
        <div className={classes.list}>
          <GlueScroll>
            {props.items?.map((item) => (
              <GlueListItem
                key={item.id}
                checkbox={props.multiple}
                selected={itemIsSelected(item)}
                onPointerDown={() => selectItem(item?.id)}
                // uiAudioMessage={selaudiomessage}
                // uiHoverAudioMessage={selhoveraudiomessage}
              >
                {item?.name}
              </GlueListItem>
            ))}
          </GlueScroll>
        </div>
        {invert && drawHeader(false)}
      </Popover>
    </div>
  )
}

export default GlueDropdown
